<template>
  <article :class="['project-card', statusTone]" @click="$emit('open', product)">
    <div class="project-card__head">
      <div class="project-card__brand">
        <img src="../../../easy-mp/src/assets/index/order-logo.png" alt="项目标识" />
        <b>上消化道早期筛查</b>
      </div>
      <span class="project-card__status"><i></i>{{ product.statusName || '处理中' }}</span>
    </div>
    <div class="project-card__body">
      <div class="project-card__image">
        <img src="../../../easy-mp/src/assets/index/order-icon.png" alt="检测项目" />
      </div>
      <div class="project-card__info">
        <strong :title="product.userName || ''">{{ product.userName || '检测人待完善' }}</strong>
        <small :title="product.serialNum || ''">检测编号：{{ product.serialNum || '--' }}</small>
        <small class="project-card__person">
          <span>年龄：{{ product.userAge || '--' }}</span>
          <em v-if="product.userPhone">{{ product.userPhone }}</em>
        </small>
      </div>
    </div>
    <div class="project-card__foot">
      <span>查看检测进展与报告</span>
      <Icon type="ios-arrow-forward" />
    </div>
  </article>
</template>

<script>
export default {
  name: 'ProjectCard',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusTone () {
      const status = Number(this.product.status)
      const statusName = String(this.product.statusName || '')
      if (/异常|失败|退回|作废/.test(statusName)) return 'status--error'
      if (status === 10 || /完成|已出报告/.test(statusName)) return 'status--done'
      if (status === 2 || /送检中|寄送中/.test(statusName)) return 'status--warning'
      if (status === 3 || status === 4 || /已送检|处理中|检测中/.test(statusName)) return 'status--processing'
      return 'status--muted'
    }
  }
}
</script>

<style scoped>
.project-card { overflow: hidden; border: 1px solid #d7e8f8; border-radius: 15px; background: #fff; box-shadow: 0 7px 18px rgba(32, 103, 165, .08); cursor: pointer; transition: transform .2s ease, box-shadow .2s ease; }
.project-card:active { transform: scale(.985); box-shadow: 0 3px 10px rgba(15, 55, 90, .1); }
.project-card__head, .project-card__foot { display: flex; justify-content: space-between; align-items: center; }
.project-card__head { min-width: 0; padding: 14px 15px 12px; border-bottom: 1px solid #f1f3f6; gap: 10px; }
.project-card__brand { min-width: 0; display: flex; align-items: center; gap: 8px; }
.project-card__brand img { width: 24px; height: 24px; flex: 0 0 24px; border-radius: 50%; object-fit: contain; }
.project-card__brand b { min-width: 0; overflow: hidden; color: var(--wpc-text); font-size: 14px; text-overflow: ellipsis; white-space: nowrap; }
.project-card__status { flex: 0 0 auto; max-width: 42%; padding: 4px 9px; overflow: hidden; border-radius: 12px; color: #667085; background: #f0f2f5; font-size: 12px; text-overflow: ellipsis; white-space: nowrap; }
.project-card__status i { display: inline-block; width: 5px; height: 5px; margin: 0 5px 2px 0; border-radius: 50%; background: currentColor; }
.status--warning .project-card__status { color: #b86b06; background: #fff4df; }
.status--processing .project-card__status { color: #007de9; background: #eaf5ff; }
.status--done .project-card__status { color: #238558; background: #eaf8f1; }
.status--error .project-card__status { color: #c74343; background: #fff0f0; }
.project-card__body { display: flex; min-width: 0; padding: 16px 15px; gap: 13px; }
.project-card__image { width: 88px; height: 68px; flex: 0 0 88px; overflow: hidden; border-radius: 8px; background: #f5f8fb; }
.project-card__image img { display: block; width: 100%; height: 100%; object-fit: cover; }
.project-card__info { min-width: 0; display: flex; flex: 1; flex-direction: column; gap: 5px; }
.project-card__info strong, .project-card__info small { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.project-card__info strong { color: var(--wpc-text); font-size: 15px; }
.project-card__info small { color: var(--wpc-text-secondary); font-size: 12px; }
.project-card__person { display: flex; min-width: 0; gap: 14px; }
.project-card__person span, .project-card__person em { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.project-card__person em { min-width: 0; color: var(--wpc-text-muted); font-style: normal; }
.project-card__foot { padding: 11px 15px; color: #007de9; background: linear-gradient(90deg, #edf6ff, #f7fbff); font-size: 13px; }

@media (max-width: 340px) {
  .project-card__head { padding-right: 12px; padding-left: 12px; }
  .project-card__body { padding-right: 12px; padding-left: 12px; gap: 10px; }
  .project-card__image { width: 76px; height: 62px; flex-basis: 76px; }
  .project-card__person { gap: 8px; }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectCard.vue